import { AutoGrid, AutoGridColumn, Icon } from 'imaginarity-react-ui';
import _ from 'lodash';
import * as React from 'react';
import { WikiSC as T } from './WikiSC';

export interface WikiTableEditSelectorProps {
    rows: number;
    columns: number;
    cellWidth?: string;
    cellHeight?: string;
    selected: (rows: number, cols: number) => void;
}

export interface WikiTableEditSelectorState {
    selectCellX: number;
    selectCellY: number;
    selectCellXTemp: number;
    selectCellYTemp: number;
}
class WikiTableEditSelector extends React.Component<WikiTableEditSelectorProps, WikiTableEditSelectorState> {
    constructor(props: WikiTableEditSelectorProps) {
        super(props);

        this.state = {
            selectCellX: 0,
            selectCellY: 0,
            selectCellXTemp: 0,
            selectCellYTemp: 0
        }
    }

    public render() {
        const p = this.props;
        const s = this.state;
        const cWidth = p.cellWidth ? p.cellWidth : "20px";
        const cHeight = p.cellHeight ? p.cellHeight : "20px";
        // const size = "calc(" + ((p.columns - 1) / 8) + " * " + cHeight + ")";
        const multiplierTemp = (p.columns < 3 || p.rows < 3) ? 0.9 : 1.5;
        const multiplier = (s.selectCellX < 2 || s.selectCellY < 2) ? 0.4 : (s.selectCellX < 3 || s.selectCellY < 3) ? 0.6 : (s.selectCellX < 4 || s.selectCellY < 4) ? 1 : 1.5;
        const iconMarginTop = (s.selectCellX < 2 || s.selectCellY < 2) ? 2 : (s.selectCellX < 3 || s.selectCellY < 3) ? 3 : (s.selectCellX < 4 || s.selectCellY < 4) ? 4 : 5;
        const sizeTemp = "calc(" + multiplierTemp + " * " + cHeight + ")";
        const size = "calc(" + multiplier + " * " + cHeight + ")";
        return (
            <>
                <T.SelectCellContainer
                    onMouseLeave={this.cancelDimensionsTemp}
                    rows={p.rows}
                    cols={p.columns}
                    height={cHeight}
                    width={cWidth}
                >
                    <div style={{ position: "absolute", top: 0, left: 0 }}>
                        <AutoGrid columns={p.columns} gap={0} >
                            {
                                _.times(p.rows, r =>
                                    _.times(p.columns, c => {
                                        const row = c + 1;
                                        const col = r + 1;
                                        const active = row <= s.selectCellXTemp && col <= s.selectCellYTemp;
                                        const set = row <= s.selectCellX && col <= s.selectCellY;
                                        return (
                                            <AutoGridColumn span={1} key={`cell-${r}-${c}`}>
                                                <T.SelectCell
                                                    active={active}
                                                    set={set}
                                                    width={cWidth}
                                                    height={p.cellHeight ?? "20px"}
                                                    onMouseOver={this.getDimensionsTemp(row, col)}
                                                    onClick={this.getDimensions(row, col)}
                                                />
                                            </AutoGridColumn>
                                        )
                                    })
                                )
                            }
                        </AutoGrid>
                    </div>
                    {s.selectCellXTemp > 0 && s.selectCellYTemp > 0 &&
                        <>
                            <T.InfoContainerTemp size={sizeTemp}>
                                <Icon name="times" size={sizeTemp} marginTop={0} />
                            </T.InfoContainerTemp>
                            <T.InfoContainerTemp size={sizeTemp}>
                                {s.selectCellXTemp}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{s.selectCellYTemp}
                            </T.InfoContainerTemp>
                        </>
                    }
                    {s.selectCellX > 0 && s.selectCellY > 0 &&
                        <>
                            <T.InfoContainer
                                size={size}
                                cols={s.selectCellX}
                                rows={s.selectCellY}
                                height={cHeight}
                                width={cWidth}
                            >
                                <Icon name="times" size={size} marginTop={iconMarginTop} />
                            </T.InfoContainer>
                            <T.InfoContainer
                                size={size}
                                cols={s.selectCellX}
                                rows={s.selectCellY}
                                height={cHeight}
                                width={cWidth}
                            >
                                {s.selectCellX}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{s.selectCellY}
                            </T.InfoContainer>
                        </>
                    }
                </T.SelectCellContainer>
            </>
        );
    }
    private getDimensions = (row: number, col: number) => () => {
        this.setState({ selectCellX: row, selectCellY: col });
        this.props.selected(col, row);
    }
    private getDimensionsTemp = (row: number, col: number) => () => {
        this.setState({ selectCellXTemp: row, selectCellYTemp: col });
    }
    private cancelDimensionsTemp = () => {
        this.setState({ selectCellXTemp: 0, selectCellYTemp: 0 });
    }
}
export default WikiTableEditSelector;